import ReturnsGuestForm from '@moncler/components/clientService/ReturnsGuestForm';
import ReturnsOrdersListing from '@moncler/components/clientService/ReturnsOrdersListing';
import { UserInfoActionTypes } from '@state/features/common.types';
import { isUserAuthenticated } from '@state/features/orders.selectors';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
const ReturnExchangeFormPage = (props) => {
    const { t } = useTranslation();
    const { loading: waitingUserInfo, user: { isAuthenticated }, } = useSelector(isUserAuthenticated);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch({
            type: UserInfoActionTypes.FETCH_USERINFO,
        });
    }, []);
    if (waitingUserInfo) {
        return React.createElement("div", null, t('label.loading'));
    }
    if (isAuthenticated || props.displayOrders) {
        return (React.createElement("div", { className: "client-service" },
            React.createElement(ReturnsOrdersListing, Object.assign({}, props, { title: t('button.exchangeorder'), description: t('exchanges.selectorder'), onlyEligibleForExchange: true }))));
    }
    return (React.createElement("div", { className: "client-service" },
        React.createElement(ReturnsGuestForm, Object.assign({}, props, { isExchange: true }))));
};
export default ReturnExchangeFormPage;
